module.exports = __webpack_public_path__ + "static/SFMada-Bold-fc69b2e467d5fd295c2bd4641f7555ac.ttf";